import { __decorate, __metadata } from "tslib";
// NPM
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { OrganizationSettings } from "@/store/modules/organizationSetting.module";
import { toaster } from "@/utilities/toaster";
import { Guid } from "guid-typescript";
import _ from "lodash";
import { setInteractionMode } from "vee-validate";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import BaseMixer from "../../BaseMixer";
import simplebar from "simplebar-vue";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let OrganizationClockWorkRights = /** @class */ (() => {
    let OrganizationClockWorkRights = class OrganizationClockWorkRights extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.emptyGuid = Guid.createEmpty();
            this.isLoading = true;
            this.isAllTeamSelected = false;
            this.teams = [];
            this.searchBy = "team";
            this.selectedTeam = "";
            this.userQuery = "";
            this.result = [];
            this.searchedTeam = "";
            this.searchedUserQuery = "";
        }
        performSearch() {
            if (this.searchBy === "team") {
                if (this.selectedTeam) {
                    this.searchedTeam = this.selectedTeam;
                    this.result = this.orgClockWorkRights.teams.filter((x) => x.teamId == this.searchedTeam);
                }
            }
            else if (this.searchBy === "user") {
                if (this.userQuery) {
                    this.searchedUserQuery = this.userQuery;
                    this.result = this.orgClockWorkRights.teams
                        .map((team) => ({
                        ...team,
                        users: team.users.filter((user) => user.userName.toLowerCase().includes(this.searchedUserQuery.toLowerCase())),
                    }))
                        .filter((team) => team.users.length > 0);
                }
            }
        }
        performCancel() {
            this.selectedTeam = "";
            this.userQuery = "";
            this.searchedTeam = "";
            this.searchedUserQuery = "";
            this.result = this.orgClockWorkRights.teams;
        }
        getOrgClockWorkRights() {
            this.isLoading = true;
            OrganizationSettings.GetOrgClockWorkRights().then(() => {
                this.isLoading = false;
                this.updateCheckedStatus();
                this.result = this.orgClockWorkRights.teams;
                this.teams = this.orgClockWorkRights.teams
                    .filter((x) => x.teamId != this.emptyGuid.toString())
                    .map((x) => ({
                    id: x.teamId,
                    name: x.teamName,
                }));
            });
        }
        saveOrgClockWorkRights() {
            var users = _.flatMap(this.orgClockWorkRights.teams, (x) => x.users)
                .filter((x) => x.isChecked)
                .map((x) => x.userId);
            var distinctUsers = _.uniq(users);
            this.isLoading = true;
            OrganizationSettings.SaveOrgClockWorkRights(distinctUsers)
                .then((res) => {
                this.isLoading = false;
                toaster.ShowApiSuccess(res);
            })
                .catch((err) => {
                this.getOrgClockWorkRights();
            });
        }
        selectUser(user, team) {
            this.selectRelevantUsers(user, team);
            this.updateCheckedStatus();
        }
        selectTeam(team) {
            team.users.forEach((user) => {
                user.isChecked = team.isChecked;
                this.selectRelevantUsers(user, team);
            });
            this.updateCheckedStatus();
        }
        selectAllTeams() {
            this.orgClockWorkRights.teams.forEach((team) => team.users.forEach((x) => (x.isChecked = this.isAllTeamSelected)));
            this.updateCheckedStatus();
        }
        selectRelevantUsers(user, team) {
            this.orgClockWorkRights.teams
                .filter((t) => t.teamId != team.teamId)
                .forEach((t) => {
                t.users.forEach((u) => {
                    if (u.userId == user.userId) {
                        u.isChecked = user.isChecked;
                    }
                });
            });
        }
        updateCheckedStatus() {
            this.orgClockWorkRights.teams.forEach((t) => (t.isChecked = t.users.every((u) => u.isChecked)));
            this.isAllTeamSelected = this.orgClockWorkRights.teams.every((t) => t.isChecked);
        }
        reset() {
            this.selectedTeam = "";
            this.userQuery = "";
            this.searchedTeam = "";
            this.searchedUserQuery = "";
            this.getOrgClockWorkRights();
        }
        get orgClockWorkRights() {
            return OrganizationSettings.orgClockWorkRights;
        }
        get isResultEmpty() {
            return this.searchedUserQuery && !this.result.some((x) => x.users.length > 0);
        }
        onCanLoadChange(newVal) {
            if (newVal) {
                this.searchBy = "team";
                this.reset();
            }
        }
    };
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], OrganizationClockWorkRights.prototype, "shouldLoad", void 0);
    __decorate([
        Watch("shouldLoad"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], OrganizationClockWorkRights.prototype, "onCanLoadChange", null);
    OrganizationClockWorkRights = __decorate([
        Component({
            name: "OrganizationClockWorkRights",
            components: {
                SectionLoader,
                simplebar,
            },
        })
    ], OrganizationClockWorkRights);
    return OrganizationClockWorkRights;
})();
export default OrganizationClockWorkRights;
